// extracted by mini-css-extract-plugin
export var detailsBox = "Details-module--detailsBox--a2dca";
export var detailsBox__content = "Details-module--detailsBox__content--b09ab";
export var detailsBox__icon = "Details-module--detailsBox__icon--36401";
export var detailsBox__icon__line = "Details-module--detailsBox__icon__line--0a30c";
export var detailsBox__tag = "Details-module--detailsBox__tag--cb00d";
export var detailsBox__text = "Details-module--detailsBox__text--50b47";